<template>
  <div class="form-divider">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ks-form-divider',
  }

</script>
